export class fetchExistence {
    public correoElectronico: String;
    public numeroIdentificacion: number;
} 